
import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d6539j9of4o2fjfo9ckg';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    category: 'general',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.subject || !formData.message) return;
    if (formData.message.length > 500) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('name', formData.name);
      body.append('email', formData.email);
      body.append('subject', formData.subject);
      body.append('category', formData.category);
      body.append('message', formData.message);

      await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', category: 'general', message: '' });
    } catch {
      // silent fail
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="bg-white rounded-xl shadow-sm p-8 md:p-12 text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <i className="ri-check-line text-green-600 text-3xl"></i>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Message Sent!</h3>
        <p className="text-sm text-gray-600 mb-5">We\'ll get back to you within 24 hours.</p>
        <button
          onClick={() => setSubmitted(false)}
          className="px-5 py-2 bg-navy-600 text-white rounded-lg text-sm font-medium hover:bg-navy-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          Send Another Message
        </button>
      </div>
    );
  }

  return (
    <form id="support-contact-form" data-readdy-form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm p-5 md:p-7">
      <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-5">Send Us a Message</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Full Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="John Doe"
            required
            className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-500 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Email Address</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="john@example.com"
            required
            className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-500 focus:border-transparent"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Category</label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-500 focus:border-transparent bg-white cursor-pointer"
          >
            <option value="general">General Inquiry</option>
            <option value="recharge">Recharge Issue</option>
            <option value="bills">Bill Payment Issue</option>
            <option value="wallet">Wallet / Funding</option>
            <option value="referral">Referral Program</option>
            <option value="account">Account / Security</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Subject</label>
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Brief description of your issue"
            required
            className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-500 focus:border-transparent"
          />
        </div>
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-700 mb-1.5">Message</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Describe your issue in detail..."
          required
          maxLength={500}
          rows={5}
          className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-500 focus:border-transparent resize-none"
        ></textarea>
        <p className="text-xs text-gray-400 mt-1 text-right">{formData.message.length}/500</p>
      </div>

      <button
        type="submit"
        disabled={submitting}
        className="w-full md:w-auto px-8 py-2.5 bg-navy-600 text-white rounded-lg text-sm font-medium hover:bg-navy-700 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
      >
        {submitting ? 'Sending...' : 'Submit Ticket'}
      </button>
    </form>
  );
}
